import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PureComponent } from 'react';
import { QueryPreviewTabs } from '../types.js';
import { renderTabPanelButtonId, renderTabPanelId } from '../utils/a11y.js';
import { TreeView } from './TreeView.js';
const rootProps = {
    'aria-labelledby': renderTabPanelButtonId(QueryPreviewTabs.queryTags),
    id: renderTabPanelId(QueryPreviewTabs.queryTags),
    role: 'tabpanel',
};
export class QueryPreviewTags extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: { tags: props.tags },
        };
    }
    render() {
        const { isWideLayout, tags } = this.props;
        return (_jsx(TreeView, { rootProps: rootProps, data: tags, isWideLayout: isWideLayout }));
    }
}
